import React from "react";
import styles from "../subscription/Subscription.module.css";

function Analytics({ analytics }) {

    return (
        <div className={styles["tab-content"]}>
            <div className={styles["analytics-grid"]}>
                <div className={styles["analytics-card"]}>
                    <h2>Subscription Distribution</h2>
                    <div className={styles["analytics-item"]}>
                        <span>Active</span>
                        <span>{analytics.active}</span>
                    </div>
                    <div className={styles["analytics-item"]}>
                        <span>Trial</span>
                        <span>{analytics.trial}</span>
                    </div>
                    <div className={styles["analytics-item"]}>
                        <span>Total</span>
                        <span>{analytics.total}</span>
                    </div>
                </div>
                <div className={styles["analytics-card"]}>
                    <h2>Revenue Metrics</h2>
                    <div className={styles["analytics-item"]}>
                        <span>Monthly Revenue</span>
                        <span>{analytics.monthlyRevenue}</span>
                    </div>
                    <div className={styles["analytics-item"]}>
                        <span>Average Revenue Per User</span>
                        <span>{analytics.averageRevenuePerUser}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Analytics;